<template>
  <div style="background-color: #fff" v-title data-title="衡水滏阳中学">
    <el-row>
      <!-- 头部 -->
      <header-elem></header-elem>
      <!-- 轮播图 -->
      <rotation-elem></rotation-elem>
    </el-row>
    <!-- 内容主体 -->
    <el-row style="width: 1200px;margin: 0 auto;margin-bottom: 20px;">
      <el-col :span="24">
        <el-col :span="7">
          <!-- 左侧导航 -->
          <leftNav-elem></leftNav-elem>
        </el-col>
        <el-col :span="17">
          <el-col :span="24" class="now_position">
            <span>当前位置：</span>
            <router-link tag="a" :to="{path:'/'}">首页</router-link>
            <span>></span>
            <span>搜索结果</span>
          </el-col>
          <!-- 文章列表 -->
          <el-col :span="24" style="border: 1px solid #dbdbdb;padding: 15px 20px;">
            <p class="searchResult">“{{$route.query.keywords}}”的结果，共{{totals}}条</p>
            <template v-if="list.length == 0">
              <div class="noArticle">
                <img src="../../static/img/noArticle.png" alt />
                <p>暂无文章</p>
              </div>
            </template>
            <ul>
              <li v-for="(list,index) in list" :key="index">
                <div class="underLine_title">
                  <!-- <div
                    v-if="mobileFlag"
                    @click="mobile(list.id, '', '', list.seo_title)"
                    class="article_title"
                  >{{list.title | subStr(40)}}</div> -->
                  <router-link
                    tag="a"
                    :to="{path:'/article',query: {id:list.id, seo_title:list.seo_title}}"
                    :title="list.title"
                    class="article_title"
                  >{{list.title | subStr(40)}}</router-link>
                  <div class="article_time">{{list.updatetime}}</div>
                </div>
              </li>
            </ul>
            <!-- 分页 -->
            <div class="pageBox" v-if="list.length>0">
              <input
                type="button"
                value="首页"
                class="btn previous"
                :class="{pageGray:page == 1}"
                :disabled="page == 1"
                @click="page = 1"
              />
              <input
                type="button"
                value="上一页"
                class="btn next"
                :class="{pageGray:page == 1}"
                :disabled="page == 1"
                @click="page--"
              />
              <span class="slectedPage">{{page}}</span>
              <input
                type="button"
                value="下一页"
                class="btn next"
                :class="{pageGray:page == totalPage}"
                :disabled="page == totalPage"
                @click="page++"
              />
              <input
                type="button"
                value="尾页"
                class="btn next"
                :class="{pageGray:page == totalPage}"
                :disabled="page == totalPage"
                @click="page = totalPage"
              />
              <span class="totalPageCss">
                共
                <b>{{totalPage}}</b>页，
                <b>{{totals}}</b>条记录，
              </span>
              到第
              <input
                type="text"
                min="1"
                class="pageInput"
                :value="goPage"
                id="J_jumpPage"
              />
              页
              <input
                type="button"
                class="btn"
                value="确定"
                @click="init($route.query.keywords, goPage, 'fenye')"
              />
            </div>
          </el-col>
          <el-col :span="24"></el-col>
        </el-col>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <el-row>
      <el-col :span="24">
        <footer-elem></footer-elem>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import headerElem from "@/components/com/header";
import rotationElem from "@/components/com/rotation";
import footerElem from "@/components/com/footer";
import leftNavElem from "@/components/com/leftNav";

var that;

export default {
  components: {
    "header-elem": headerElem,
    "rotation-elem": rotationElem,
    "footer-elem": footerElem,
    "leftNav-elem": leftNavElem
  },
  data() {
    return {
      totals: 0, //文章总篇数
      totalPage: 1, //总页码
      page: 1, //当前页码
      goPage: 1, //跳转页码
      count: 10, //每页展示多少条
      list: [],
      // mobileFlag: ""
    };
  },
  mounted() {
    that = this;
    that.init(that.$route.query.keywords, 1, "");
    // if (isMobile()) {
    //   that.mobileFlag = true;
    // } else {
    //   that.mobileFlag = false;
    // }
    // console.log(that.mobileFlag);
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0);
    next();
  },
  beforeRouteUpdate(to, from, next) {
    //在当前路由改变，但是该组件被复用时调用
    that.init(to.query.keywords, 1, "");
    next();
  },
  beforeRouteLeave(to, from, next) {
    var position = $(document).scrollTop();
    sessionStorage.setItem("searchScrollHei", position);
    console.log("beforeRouteLeave");
    next();
  },
  updated() {
    that.$nextTick(function() {
      var position = Number(sessionStorage.getItem("searchScrollHei"));
      $(document).scrollTop(position);
    });
  },
  methods: {
    // mobile(id, fId, sId, seo_title) {
    //   location.href =
    //     "http://www.hsfyzx.cn/mobile/index.html#/article?id=" +
    //     id +
    //     "&fId=" +
    //     fId +
    //     "&sId=" +
    //     sId +
    //     "&seo_title=" +
    //     seo_title;
    // },
    init(keywords, page, from) {
      if (from && from === "fenye") {
        that.page = Number(document.getElementById("J_jumpPage").value);
        that.goPage = Number(document.getElementById("J_jumpPage").value);
      }
      $.ajax({
        type: "get",
        url: url + "/search?keywords=" + keywords + "&page=" + page,
        success: function(data) {
          if (data.code == "0") {
            that.list = data.data;
            that.totals = data.count;
            if (
              Number(that.totals) > 0 &&
              Number(that.totals) % Number(10) > 0
            ) {
              that.totalPage =
                parseInt(Number(that.totals) / Number(that.count)) + 1; //总页码
            } else {
              that.totalPage = parseInt(
                Number(that.totals) / Number(that.count)
              );
            }
          }
        },
        error(data) {
          // alert(data.msg);
        }
      });
    }
  },
  filters: {
    subStr(val, num) {
      if (val.length > num) {
        return val.substring(0, num) + "...";
      } else {
        return val;
      }
    },
    timesubStr(val) {
      return val.substring(0, 10);
    }
  },
  watch: {
    page() {
      that.init(that.$route.query.keywords, that.page, "");
    }
  }
};
</script>
<style scoped>
.now_position {
  text-align: right;
}
.underLine_title {
  min-height: 35px;
}
.article_title,
.article_time {
  line-height: 35px;
}
.article_time {
  font-size: 12px;
  color: #a8a8a8;
}
.searchResult {
  margin-left: 10px;
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/search.vue